export const BACK_TO_BACK_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  accountName: 'accountName',
  accountId: 'accountId',
  isccCertificateNumber: 'isccCertificateNumber',
  officialSiteName: 'officialSiteName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  cityName: 'cityName',
  countryName: 'countryName',
  zipCode: 'zipCode',
});

export const BACK_TO_BACK_SORT_FIELDS = Object.freeze({
  [BACK_TO_BACK_COLUMNS.accountName]: 'accountName',
  [BACK_TO_BACK_COLUMNS.accountId]: 'accountId',
  [BACK_TO_BACK_COLUMNS.isccCertificateNumber]: 'isccCertificateNumber',
  [BACK_TO_BACK_COLUMNS.officialSiteName]: 'officialSiteName',
  [BACK_TO_BACK_COLUMNS.addressLine1]: 'addressLine1',
  [BACK_TO_BACK_COLUMNS.addressLine2]: 'addressLine2',
  [BACK_TO_BACK_COLUMNS.cityName]: 'cityName',
  [BACK_TO_BACK_COLUMNS.countryName]: 'countryName',
  [BACK_TO_BACK_COLUMNS.zipCode]: 'zipCode',
});

export const BACK_TO_BACK_SEARCH_IN = Object.freeze(['account_name']);

export const BACK_TO_BACK_FIELDS = Object.freeze({
  accountName: 'accountName',
  accountId: 'accountId',
  isccCertificateNumber: 'isccCertificateNumber',
  isccVerified: 'isccVerified',
  validFrom: 'validFrom',
  validTill: 'validTill',
  officialSiteName: 'officialSiteName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  cityName: 'cityName',
  countryName: 'countryName',
  zipCode: 'zipCode',
});

export const EMPTY_BACK_TO_BACK_FORM = Object.freeze({
  [BACK_TO_BACK_FIELDS.accountName]: '',
  [BACK_TO_BACK_FIELDS.accountId]: '',
  [BACK_TO_BACK_FIELDS.isccCertificateNumber]: '',
  [BACK_TO_BACK_FIELDS.isccVerified]: false,
  [BACK_TO_BACK_FIELDS.validFrom]: '',
  [BACK_TO_BACK_FIELDS.validTill]: '',
  [BACK_TO_BACK_FIELDS.officialSiteName]: '',
  [BACK_TO_BACK_FIELDS.addressLine1]: '',
  [BACK_TO_BACK_FIELDS.addressLine2]: '',
  [BACK_TO_BACK_FIELDS.cityName]: '',
  [BACK_TO_BACK_FIELDS.countryName]: '',
  [BACK_TO_BACK_FIELDS.zipCode]: '',
});

export const REQUIRED_BACK_TO_BACK_FIELDS = Object.freeze([
  BACK_TO_BACK_FIELDS.accountName,
  BACK_TO_BACK_FIELDS.accountId,
  BACK_TO_BACK_FIELDS.officialSiteName,
  BACK_TO_BACK_FIELDS.addressLine1,
  BACK_TO_BACK_FIELDS.cityName,
  BACK_TO_BACK_FIELDS.countryName,
  BACK_TO_BACK_FIELDS.zipCode,
]);
